(function () {
    'use strict';

    angular.module("imApp").factory("forecastsService", ['$ihttp', function ($ihttp) {
        let service = {
            listForecasts: function (parms) {
                return $ihttp.post({
                    method: 855,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
